import React, { useContext, createContext } from 'react';
import { useLocalStore } from 'mobx-react-lite';

// import { connectReduxDevtools } from 'mst-middlewares';

/**
 * Convenience utility to easily create providers and hooks for a MST store
 *
 * @param {*} rootStore the main MST store to create a hook for
 * @returns object containinng the store provider and a hook to access the store
 */

var createUseStoreHook = function createUseStoreHook(rootStore) {
  // utility functions
  var createStore = function createStore(seed) {
    return function () {
      return rootStore.create(seed);
    };
  };
  var storeContext = /*#__PURE__*/createContext(null);

  // component to be exposed to developer
  var Provider = function Provider(_ref) {
    var children = _ref.children,
      seed = _ref.seed,
      _ref$storeFns = _ref.storeFns,
      storeFns = _ref$storeFns === void 0 ? [] : _ref$storeFns;
    var store = useLocalStore(createStore(seed));
    // connectReduxDevtools(require('remotedev'), store);

    if (storeFns.length) {
      storeFns.forEach(function (func) {
        return func(store);
      });
    }
    return /*#__PURE__*/React.createElement(storeContext.Provider, {
      value: store
    }, children);
  };
  // hook to be exposed to developer
  var useStore = function useStore() {
    var store = useContext(storeContext);
    if (!store) {
      // this is especially useful in TypeScript so you don't need to be checking for null all the time
      throw new Error('useStore must be used within a StoreProvider.');
    }
    return store;
  };
  return {
    Provider: Provider,
    useStore: useStore
  };
};

export { createUseStoreHook };
